/** @jsx builderX.jsx */

import {builderX, Sprite, Image} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name="waterMark_landscape">
        <Sprite name="balanceContainer">
            <Image position={[3400, 0]} name="bgBottom" src="net_balance_black_mob_l"/>
            <Sprite position={[3800, 22]} name="labelBalanceContainer"/>
        </Sprite>
        <Sprite position={[0, 92]} name="clockContainer">
            <Image position={[3460, 1640]} name="bgTop" src="timer_black_back"/>
            <Image position={[3510, 1660]} name="ui_timer_icon" src="ui_timer_icon"/>
            <Sprite position={[3690, 1654]} name="labelClockContainer"/>
        </Sprite>
        <Sprite position={[0, 92]} name="globalClockContainer">
            <Image position={[3460, 1640]} name="bgTop" src="timer_black_back"/>
            <Sprite position={[3690, 1654]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="globalClockContainer_pure">
            <Image position={[-380, 0]} name="bgTop" src="timer_black_back"/>
            <Sprite position={[-135, 17]} name="labelClockContainer"/>
        </Sprite>
        <Sprite name="gameNameContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionEarningsContainer">
            <Image position={[3400, 380]} name="bgBottom" src="net_balance_black_mob_l"/>
            <Sprite position={[3800, 402]} name="labelContainer"/>
        </Sprite>
        <Sprite name="sessionBetsContainer">
            <Image position={[3400, 560]} name="bgBottom" src="net_balance_black_mob_l"/>
            <Sprite position={[3800, 582]} name="labelContainer"/>
        </Sprite>
        <Sprite position={[0, 530]} name="maxWinProbabilityContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
        <Sprite position={[0, 99]} name="RTPContainer">
            <Sprite name="labelContainer"/>
        </Sprite>
    </Sprite>
);
